import useFilters from 'composables/useFilters';
import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  setup() {
    const { getCardSelected } = useFilters();
    return {
      cardSelected: getCardSelected,
    };
  },
})
export default class SkeletonSearchResultComponent extends Vue {
  isBox = 0;
}
